import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-ink" data-id="element-63" data-mp="3gfiv8kpoaff6">
      <div className="mx-auto max-w-4xl px-5 py-14 text-center pt-[6px]" data-id="element-64" data-mp="3ghc0bvkn0rl2">
        <p className="font-display text-xl font-black text-white" data-id="element-65" data-mp="32pfh6h0y5s0t">
          MegaPack Fiesta Épica<span className="align-super text-xs" data-id="element-66" data-mp="36q953aee36tp">™</span>
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-white/60" data-id="element-67" data-mp="3ueil1vox90cx">
          El sistema de organización N°1 para cumpleaños infantiles de Argentina. Porque el
          cumpleaños de tu hijo no debería costarte semanas de estrés y noches sin dormir.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/70" data-id="element-68" data-mp="3qdf2v2jeis8j">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors hover:text-iris-soft" data-id="element-69" data-mp="29zgo8ajmtaqv">
            <MailIcon className="h-4 w-4 text-iris-soft" data-id="element-70" data-mp="2ez1nyn6mln4n" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors hover:text-iris-soft" data-id="element-71" data-mp="3la2a6wqof7wa">
            <InstagramIcon className="h-4 w-4 text-iris-soft" data-id="element-72" data-mp="3gc0ixoj3k29q" /> @sigmasmartoficial
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors hover:text-iris-soft" data-id="element-73" data-mp="3v9az3b6opwbs">
            <GlobeIcon className="h-4 w-4 text-iris-soft" data-id="element-74" data-mp="3q7bvc0718xeb" /> www.sigmasmart.store
          </a>
        </div>

        <p className="mt-4 font-display text-base italic text-iris-soft" data-id="element-75" data-mp="80xjc6sbqxik">
          “El cumpleaños que tu hijo va a recordar siempre empieza hoy.” 🎂
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/40" data-id="element-76" data-mp="hrs7xht1m976">
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-77" data-mp="cus134odd2f0">
            Términos y condiciones
          </a>
          <span data-id="element-78" data-mp="qu1j89w4y6lm">·</span>
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-79" data-mp="qr5gm89cetqu">
            Política de privacidad
          </a>
          <span data-id="element-80" data-mp="tvczxt1gc7fo">·</span>
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-81" data-mp="tw5yi6q9bqmq">
            Soporte
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-white/35" data-id="element-82" data-mp="yupjo4x10ye1">
          © 2026 Fiesta Épica™ — Todos los derechos reservados. Prohibida la reproducción y
          redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}